module.exports = __webpack_public_path__ + "media/images/bible_studies-2ab965a5.jpg";